import {
  Button,
  Container,
  Flex,
  FormControl,
  FormErrorMessage,
  Heading,
  Input,
  InputGroup,
  InputLeftElement,
  Stack,
  Text
} from '@chakra-ui/react';
import { useState } from 'react';
import Phone from '../icons/Phone';
import useAuth from '../hooks/useAuth';
import VerifyOtpDrawer from '../components/VerifyOtpDrawer';
import { normalize } from '../lib/normalize-phone-number';
import { useNavigate } from 'react-router-dom';

const Authenticate = () => {
  const navigate = useNavigate();

  const [phoneNumber, setPhoneNumber] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<{ phone?: string | null; otp?: string | null }>(null!);
  const [otpStatus, setOtpStatus] = useState<'invalid' | 'success' | null>(null);

  const { sendingOtp, sendOtp, veryfyOtp, verifying, setToken } = useAuth();

  const handleGetOtp = async () => {
    const validPhoneNumber = normalize(phoneNumber);
    const results = await sendOtp(validPhoneNumber);

    if (results.errors) {
      setError({ phone: results.errors[0].message });
    } else {
      setSent(true);
    }
  };

  const handleVerifyOtp = async (otp: string) => {
    const results = await veryfyOtp(otp);

    if (results.errors) {
      setOtpStatus('invalid');
    } else {
      // Valid opt action
      setOtpStatus('success');

      console.log(results);
      if (results) {
        setToken(results?.data?.completeMemberLogin?.accessToken);
      }

      setTimeout(() => {
        navigate('/');
      }, 2000);
    }
  };

  return (
    <Container>
      <Flex
        direction='column'
        justifyContent='center'
        h='100vh'
        pl={5}
        pr={4}
        py={3}
      >
        <Flex justify='space-between' alignItems='center'>
          <Stack spacing={4} w='full'>
            <Heading as='h5' size='sm' color='#0f172a'>
              Enter Phone Number
            </Heading>
            <Text fontSize='sm' color='#475569'>
              We will send an OTP message
            </Text>

            <FormControl isInvalid={Boolean(error?.phone)}>
              <InputGroup mt={6}>
                <InputLeftElement pointerEvents='none'>
                  <Phone color='gray.300' />
                </InputLeftElement>
                <Input
                  type='tel'
                  placeholder='+254 712 345 678'
                  bg='white'
                  inputMode='numeric'
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.currentTarget.value)}
                />
              </InputGroup>
              {Boolean(error?.phone) && (
                <FormErrorMessage mt={4}>{error?.phone}</FormErrorMessage>
              )}
            </FormControl>

            <Button
              mt={4}
              size='md'
              style={{ color: '#fff', background: '#2563eb' }}
              onClick={handleGetOtp}
              isLoading={sendingOtp}
              loadingText='Sending...'
              disabled={phoneNumber === '' || phoneNumber.length < 9}
            >
              Get Otp
            </Button>
          </Stack>
        </Flex>
      </Flex>

      <VerifyOtpDrawer
        sent={sent}
        phoneNumber={phoneNumber}
        isInvalid={otpStatus === 'invalid'}
        isSuccess={otpStatus === 'success'}
        onVerifyOtp={handleVerifyOtp}
        verifying={verifying}
        onResendOtp={handleGetOtp}
        resending={sendingOtp}
      />
    </Container>
  );
};

export default Authenticate;
